module.exports = __webpack_public_path__ + "img/camelia.16ade3fe.jpg";